import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

/**
 * Progresso circular com percentual central.
 * Cores padrão alinhadas ao tema de importação (/trading/import).
 */
export default function CircularProgressWithLabel({
    value,
    size = 72,
    thickness = 4,
    ringColor = '#f29205',
    labelColor = '#ffffff',
}) {
    const v = Math.min(100, Math.max(0, Number(value) || 0));

    return (
        <Box sx={{ position: 'relative', display: 'inline-flex', width: size, height: size }}>
            <CircularProgress
                variant="determinate"
                value={v}
                size={size}
                thickness={thickness}
                sx={{
                    color: ringColor,
                    '& .MuiCircularProgress-circle': {
                        strokeLinecap: 'round',
                    },
                }}
            />
            <Box
                sx={{
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    position: 'absolute',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <Typography
                    component="div"
                    sx={{
                        color: labelColor,
                        fontSize: Math.max(13, size * 0.17),
                        fontWeight: 700,
                        fontVariantNumeric: 'tabular-nums',
                    }}
                >
                    {`${Math.round(v)}%`}
                </Typography>
            </Box>
        </Box>
    );
}
